import styled, { css, RuleSet } from 'styled-components'

type ContainerOptionType =
  | 'flex_column'
  | 'flex_row'
  | 'flex_row_space_between'
  | 'flex_column_space_between'
  | 'flex_row_wrap'
export interface ContainerProps {
  $option?: ContainerOptionType
  $style?: RuleSet<object>
  $column_gap?: string
  $row_gap?: string
  $width?: string
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${(props) => props.$width || '100%'};
  ${(props) =>
    props.$option === 'flex_column' &&
    css`
      display: flex;
      flex-direction: column;
    `}
  ${(props) =>
    props.$option === 'flex_row' &&
    css`
      display: flex;
      flex-direction: row;
    `}
  ${(props) =>
    props.$option === 'flex_row_wrap' &&
    css`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    `}
  ${(props) =>
    props.$option === 'flex_row_space_between' &&
    css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    `}
  ${(props) =>
    props.$option === 'flex_column_space_between' &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    `}
  
  column-gap: ${(props) => props.$column_gap};
  row-gap: ${(props) => props.$row_gap};

  ${(props) => props.$style};
`
